import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "./Text";
import { View } from "./View";
/**
 * Displays a US based address in standard formatting
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-129}
 */ export function UserAddress(props) {
    var _props_line;
    if ('line1' in props) {
        return /*#__PURE__*/ _jsxs(View, {
            children: [
                props.line1 ? /*#__PURE__*/ _jsx(Text, {
                    testID: "UserAddress_line1",
                    text: props.line1
                }) : null,
                props.line2 ? /*#__PURE__*/ _jsx(Text, {
                    testID: "UserAddress_line2",
                    text: props.line2
                }) : null,
                /*#__PURE__*/ _jsx(Text, {
                    testID: "UserAddress_cityStateZip",
                    text: "".concat(props.city || '', ", ").concat(props.state || '', " ").concat(props.zip || '')
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(View, {
        children: [
            (_props_line = props.line) === null || _props_line === void 0 ? void 0 : _props_line.map(function(line) {
                return /*#__PURE__*/ _jsx(Text, {
                    text: line
                }, line);
            }),
            /*#__PURE__*/ _jsx(Text, {
                testID: "UserAddress_cityStateZip",
                text: "".concat(props.city || '', ", ").concat(props.state || '', " ").concat(props.postalCode || '')
            })
        ]
    });
}
